<template>
  <b-button
    variant="primary"
    @click="create"
    :disabled="!creatable"
  >
    <b-icon
      icon="plus"
    />
    作成
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'user/new'
    }
  },

  computed: {
    creatable () {
      return this.$store.getters[`${this.modelName}/creatable`]
    }
  },

  methods: {
    async create () {
      this.$store.dispatch('loading/show')
      const result = await this.$store.dispatch(`${this.modelName}/create`)
      this.$store.dispatch('loading/hide')

      if (result) {
        this.$store.dispatch('toast/show', {
          content: 'メンバーを登録しました。',
          title: 'メンバー登録'
        })
        this.$router.back(-1)
      }
    }
  }
}
</script>
